function RealPenLettersIcon() {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 14.64 18.25">
            <path
                className="bg-white"
                fill="#ffffff"
                d="M4.73,5H7.28a.14.14,0,0,0,0-.28H4.73a.14.14,0,0,0,0,.28Z"
                transform="translate(-2.68 -0.88)"
            />
            <path
                className="bg-white"
                fill="#ffffff"
                d="M14.19,10.56a.14.14,0,0,0,0-.28H4.72a.14.14,0,0,0,0,.28Z"
                transform="translate(-2.68 -0.88)"
            />
            <path
                className="bg-white"
                fill="#ffffff"
                d="M16.06,1.87l.18-.3a.27.27,0,0,1,.37-.07.26.26,0,0,1,.08.35l-.18.3.2.12c.13-.25.34-.76.61-.7A1.13,1.13,0,0,0,16.89,1a1.07,1.07,0,0,0-.66-.1c.21.2-.32.75-.38.85Z"
                transform="translate(-2.68 -0.88)"
            />
            <path
                className="bg-white"
                fill="#ffffff"
                d="M14.19,11.59a.14.14,0,0,0,0-.28H4.72a.14.14,0,0,0,0,.28Z"
                transform="translate(-2.68 -0.88)"
            />
            <path
                className="bg-white"
                fill="#ffffff"
                d="M14.19,12.67a.14.14,0,0,0,.14-.14.14.14,0,0,0-.14-.14H4.72a.14.14,0,0,0-.14.14.14.14,0,0,0,.14.14Z"
                transform="translate(-2.68 -0.88)"
            />
            <path
                className="bg-white"
                fill="#ffffff"
                d="M14.19,13.84a.14.14,0,0,0,0-.28H4.72a.14.14,0,0,0,0,.28Z"
                transform="translate(-2.68 -0.88)"
            />
            <path
                className="bg-white"
                fill="#ffffff"
                d="M14.19,14.87a.14.14,0,1,0,0-.28H4.72a.14.14,0,0,0,0,.28Z"
                transform="translate(-2.68 -0.88)"
            />
            <path
                className="bg-white"
                fill="#ffffff"
                d="M14.19,16a.14.14,0,1,0,0-.28H4.72a.14.14,0,0,0,0,.28Z"
                transform="translate(-2.68 -0.88)"
            />
            <path
                className="bg-white"
                fill="#ffffff"
                d="M14.19,17a.14.14,0,0,0,.14-.14.15.15,0,0,0-.14-.15H4.72a.15.15,0,0,0-.14.15.14.14,0,0,0,.14.14Z"
                transform="translate(-2.68 -0.88)"
            />
            <path
                className="bg-white"
                fill="#ffffff"
                d="M16.68,2.49a2.61,2.61,0,0,0-.28-.17l-.27.44-.25.41-.17.28-.23.37-.37.61a.26.26,0,0,1-.45-.27h0L15,3.57l.23-.38,0,0,.25-.41L16,2.05l-.34-.19a.28.28,0,0,0-.4.09s-.18.33-.44.81l-.06.12H4a1.3,1.3,0,0,0-1.3,1.3V17.82A1.3,1.3,0,0,0,4,19.12h11a1.31,1.31,0,0,0,1.31-1.3V4.18a1.34,1.34,0,0,0,0-.35l.43-.66A2.33,2.33,0,0,1,16.75,3a.5.5,0,0,0,.08-.2A.25.25,0,0,0,16.68,2.49ZM14.93,18.14H4a.33.33,0,0,1-.32-.32V4.18A.33.33,0,0,1,4,3.86h10.2c-.33.61-.69,1.29-1,2H4.72a.14.14,0,0,0,0,.28H13l-.1.18c-.05.09-.1.18-.14.27s-.11.2-.16.3l-.05.08H4.72a.14.14,0,0,0,0,.28h7.67a.54.54,0,0,0-.05.11c-.14.25-.26.49-.37.69V8H4.72a.14.14,0,0,0-.14.14.15.15,0,0,0,.14.15H11.9c-.06.27-.15.56-.21.83h-7a.14.14,0,0,0-.14.14.14.14,0,0,0,.14.14h7l-.11.34a0,0,0,0,0,0,.05h0l.26-.25,0,0,.2-.17h2a.14.14,0,0,0,.14-.14.14.14,0,0,0-.14-.14H12.46l.28-.27A2.83,2.83,0,0,1,13,8.66l.22-.33h.95a.14.14,0,0,0,.14-.14.14.14,0,0,0-.14-.14h-.77l.08-.11.21-.33.26-.4h.22a.14.14,0,0,0,.14-.14.14.14,0,0,0-.14-.14h0l.43-.65c.09-.13.18-.26.26-.4s.28-.42.41-.63V17.82A.32.32,0,0,1,14.93,18.14Z"
                transform="translate(-2.68 -0.88)"
            />
        </svg>
    )
}

export default RealPenLettersIcon
